import _ from 'lodash';
import { getUUID, getXIds } from '../../../../utils';
const newTemplate = 'New Template';
const newCubicle = 'New Cubicle';
const styleStr = '{"color":"white","text-align":"center","background-color":"blue"}';

const ItemTypes = {
  dutyIC: 'DutyIC',
  onDuty: 'OnDuty',
};

const C = {
  groupId: 'dutyTemplateGroupId',
  templateName: 'templateName',
  groups: 'rosterGroups',
  groupName: 'groupName',
  functions: 'functionalAreas',
  functionName: 'functionalAreaName',
  srcCodes: 'templateMappings',
  srsRankCode: 'srsRankCode',
  srsShiftCode: 'srsShiftCode',
  rosterLeadDay: 'rosterLeadDay',
  staffs: 'staffs',
  srsWardCode: 'srsUnitCode',
  templateId: 'dutyTemplateWardId',
  funcStyle: 'functionalAreaStyle',
  groupStyle: 'groupStyle',
  groupIsHide: 'isHide',
  hospitalId: 'hospitalId',
  wardId: 'wardId',
  groupOrder: 'groupOrder',
  funcOrder: 'areaOrder',
  fId: 'dutyTemplateFunctionalAreaId',
  gId: 'dutyTemplateGroupId',
  _fId: 'fid',
  // _fId: 'dutyTemplateFunctionalAreaId',
  _gId: '_gId',
  isDeleted: 'isDeleted',
  isSmartCommunication: 'isSmartCommunication',
  groupType: 'groupType',
  height: 'height',
  dutyTemplateMappingId: 'dutyTemplateMappingId',
};

const initFunction = (functionName, order, fid, height) => {
  const result = {
    [C.functionName]: functionName,
    [C.funcStyle]: styleStr,
    [C.funcOrder]: order,
    [C._fId]: fid,
    [C.height]: height ?? 4,
    [C.srcCodes]: [],
  };
  return result;
};

const mapGroups = {
  1: {
    [C.groupName]: 'Duty IC',
    [C.groupStyle]: styleStr,
    [C.groupIsHide]: 0,
    [C.groupOrder]: 0,
    [C._gId]: [C._gId] + 0,
    [C.groupType]: 1,
    [C.functions]: [
      initFunction('COS', 0, 0),
      initFunction('DOM', 1, 1),
      initFunction('WM', 2, 2),
      initFunction('DAY I&C', 3, 3),
    ],
  },
  2: {
    [C.groupName]: 'On Duty',
    [C.groupStyle]: styleStr,
    [C.groupIsHide]: 0,
    [C.groupOrder]: 1,
    [C._gId]: [C._gId] + 1,
    [C.groupType]: 2,
    [C.functions]: [
      initFunction('Cubicle  A', 0, 0, 4),
      initFunction('Cubicle  B', 1, 1, 4),
      initFunction('Cubicle  C', 2, 2, 4),
    ],
  },
  3: {
    [C.groupName]: 'Leave',
    [C.groupStyle]: styleStr,
    [C.groupIsHide]: 0,
    [C.groupOrder]: 2,
    [C._gId]: [C._gId] + 2,
    [C.groupType]: 3,
    [C.functions]: [initFunction('Sick Leave', 0, 0, 4), initFunction('Day Off', 1, 1, 4)],
  },
};

const initTemplateData = () => {
  const ids = getXIds();
  const hospitalId = ids.hospitalId;
  const wardId = ids.wardId;
  return {
    [C.templateName]: newTemplate,
    [C.hospitalId]: hospitalId,
    [C.wardId]: wardId,
    [C.isSmartCommunication]: 0,
    [C.groups]: [
      JSON.parse(JSON.stringify(mapGroups[1])),
      JSON.parse(JSON.stringify(mapGroups[2])),
      JSON.parse(JSON.stringify(mapGroups[3])),
    ],
  };
};

let deleteIds = {};
const addDeleteGroup = (allGroup, index) => {
  const groupData = allGroup ? allGroup[index] : null;
  const groupId = groupData[C.gId];
  if (deleteIds.hasOwnProperty(groupId)) {
    if (groupData && (groupId === 0 || groupId)) {
      deleteIds[groupId] = {
        ...deleteIds[groupId],
        [C.isDeleted]: 1,
        [C.functions]: [
          ...deleteIds[groupId][C.functions],
          ..._.map(groupData[C.functions], (item) => {
            return { ...item, [C.isDeleted]: 1 };
          }),
        ],
      };
    }
  } else if (groupData && (groupId === 0 || groupId)) {
    deleteIds[groupId] = { ...groupData, [C.isDeleted]: 1 };
    groupData[C.functions] = _.map(groupData[C.functions], (item) => {
      return { ...item, [C.isDeleted]: 1 };
    });
  }
};
const addDelectFunc = (groupData, index) => {
  const funcData = groupData ? groupData[C.functions][index] : null;
  const funcId = funcData[C.fId];
  if (funcData && (funcId === 0 || funcId)) {
    const groudId = groupData[C.gId];
    if (!deleteIds[groudId]) {
      deleteIds[groudId] = { ...groupData };
      deleteIds[groudId][C.functions] = [];
    }
    deleteIds[groudId][C.functions].push({
      ...funcData,
      [C.isDeleted]: 1,
    });
  }
  console.log('deleteIds', deleteIds);
};

const allDataFunc = {
  getTemplateData: (allData, id) => {
    if (id === undefined) return null;
    if (Array.isArray(allData)) {
      return _.find(allData, (item) => {
        return item[C.templateId] === Number(id);
      });
    }
  },
};

const templateFunc = {
  initTemplateDate: () => {
    return initTemplateData;
  },
  isDeletedGroupType: (allData, groupType) => {
    return !_.some(allData?.[C.groups], (item) => {
      return item[C.groupType] === groupType;
    });
  },
  addGroupUseType: (allData, groupType) => {
    let index = _.findIndex(allData?.[C.groups], (item) => {
      return item[C.groupType] > groupType;
    });
    index = index >= 0 ? index : allData?.[C.groups]?.length;
    allData[C.groups].splice(index, 0, { ...JSON.parse(JSON.stringify(mapGroups[groupType])), [C._gId]: getUUID() });
    return allData ? { ...allData } : null;
  },
  mergeAllDelete: function (allData) {
    const newDelete = { ...deleteIds };
    const allGroup = this.getAllGroup(allData);
    const tempAllGroup = _.map(allGroup, (groupItem, groupIndex) => {
      const groupId = groupItem[C.gId];
      if (newDelete.hasOwnProperty(groupId)) {
        const allFunc = groupDataFunc.getAllFunction(groupItem);
        const tempDelete = newDelete[groupId][C.functions];
        delete newDelete[groupId];
        return { ...groupItem, [C.functions]: [...allFunc, ...tempDelete] };
      }
      return { ...groupItem, [C.groupOrder]: groupIndex };
    });
    return { ...allData, [C.groups]: [...tempAllGroup, ...Object.values(newDelete)] };
  },
  order: function (allData) {
    const allGroup = this.getAllGroup(allData);
    const newAllGroup = _.sortBy(allGroup, (item) => {
      return item[C.groupOrder];
    });
    return {
      ...allData,
      [C.groups]: _.map(newAllGroup, (groupItem) => {
        return {
          ...groupItem,
          [C.functions]: _.sortBy(groupDataFunc.getAllFunction(groupItem), (item) => {
            return item[C.funcOrder];
          }),
        };
      }),
    };
  },
  getAllGroup: (allData) => {
    return allData ? allData[C.groups] : null;
  },
  getGroup: function (allData, index) {
    const allGroup = this.getAllGroup(allData);
    return allGroup ? allGroup[index] : null;
  },
  setGroup: function (allData, index, groupData) {
    const allGroup = this.getAllGroup(allData);
    return {
      ...allData,
      [C.groups]: _.map(allGroup, (item, iIndex) => {
        if (iIndex === index) {
          return groupData;
        }
        return item;
      }),
    };
  },
  getGroupAllFunction: function (allData, groupIndex) {
    const group = this.getGroup(allData, groupIndex);
    return group ? group[C.functions] : null;
  },
  getFunction: function (allData, groupIndex, functionIndex) {
    const allFunction = this.getGroupAllFunction(allData, groupIndex);
    return allFunction ? allFunction[functionIndex] : null;
  },
  getTemplateName: (allData) => {
    return allData ? allData[C.templateName] : '';
  },
  setTemplateName: (allData, name) => {
    return { ...allData, [C.templateName]: name };
  },
  getIsSmartCommunication: (allData) => {
    return allData ? allData[C.isSmartCommunication] : '';
  },
  setIsSmartCommunication: (allData, isSmartCommunication) => {
    return { ...allData, [C.isSmartCommunication]: isSmartCommunication };
  },
  getHeadGroup: function (allData) {
    const allGroup = this.getAllGroup(allData);
    return allGroup ? allGroup[0] : null;
  },
  getBodyGroups: function (allData) {
    return _.filter(this.getAllGroup(allData), (item, index) => {
      return index !== 0;
    });
  },
  delectGroup: function (allData, index) {
    const allGroup = this.getAllGroup(allData);
    addDeleteGroup(allGroup, index);
    return {
      ...allData,
      [C.groups]: _.filter(allGroup, (item, iIndex) => {
        return index !== iIndex;
      }),
    };
  },
  deleteTemplate: function (allData) {
    return allData ? { ...allData, [C.isDeleted]: 1 } : null;
  },
  resetDeleteIds: () => {
    deleteIds = {};
  },
};



const groupDataFunc = {
  getAllFunction: (allData) => {
    return allData ? allData[C.functions] : null;
  },
  getFunction: function (allData, functionIndex) {
    const allFunction = this.getAllFunction(allData);
    return allFunction ? allFunction[functionIndex] : null;
  },
  getGroupName: (allData) => {
    return allData ? allData[C.groupName] : '';
  },
  setGroupName: (allData, groupName) => {
    return allData ? { ...allData, [C.groupName]: groupName } : null;
  },
  getHide: (allData) => {
    return allData ? allData[C.groupIsHide] : null;
  },
  setHide: (allData, isHide) => {
    return allData ? { ...allData, [C.groupIsHide]: isHide } : null;
  },
  addFunction: (allData) => {
    const maxOrder = _.maxBy(allData[C.functions], C.funcOrder)?.[C.funcOrder] ?? 0;
    const max_fid = _.maxBy(allData[C.functions], C._fId)?.[C._fId] ?? 0;
    const maxfid = _.maxBy(allData[C.functions], C.fId)?.[C.fId] ?? 0;
    return {
      ...allData,
      [C.functions]: [
        ...allData[C.functions],
        initFunction(newCubicle, maxOrder + 1, max_fid > maxfid ? max_fid + 1 : maxfid + 1),
      ],
    };
  },
  setFunction: (allData, functionPosition, functionData) => {
    return {
      ...allData,
      [C.functions]: _.map(allData[C.functions], (item, index) => {
        if (index === functionPosition) {
          return functionData;
        }
        return item;
      }),
    };
  },
  delectFunction: (allData, functionPosition) => {
    addDelectFunc(allData, functionPosition);
    return {
      ...allData,
      [C.functions]: _.filter(allData[C.functions], (item, index) => {
        return index !== functionPosition;
      }),
    };
  },
  triggerFunction: function (allData, preIndex, nextIndex) {
    if (preIndex === nextIndex) {
      return allData;
    }
    const allFunc = this.getAllFunction(allData);
    const preData = allFunc[preIndex];
    const nextData = allFunc[nextIndex];
    return allFunc
      ? {
          ...allData,
          [C.functions]: _.map(allFunc, (item, index) => {
            if (index === preIndex) {
              return { ...nextData, [C.funcOrder]: index };
            } else if (index === nextIndex) {
              return { ...preData, [C.funcOrder]: index };
            }
            return { ...item, [C.funcOrder]: index };
          }),
        }
      : null;
  },
  getGroupOrder: (allData) => {
    return allData ? allData[C.groupOrder] : null;
  },
  getGroupId: (allData) => {
    if (allData) {
      if (allData[C.gId] === 0 || allData[C.gId]) {
        return allData[C.gId];
      }
      return allData[C._gId];
    }
    return null;
  },
  reNameDutyIC: function (allData, index, title) {
    const allFunc = this.getAllFunction(allData);
    return {
      ...allData,
      [C.functions]: _.map(allFunc, (item, itemIndex) => {
        if (itemIndex === index) {
          return {
            ...item,
            [C.functionName]: title,
          };
        }
        return item;
      }),
    };
  },
  isDutyIC: function (allData) {
    return allData?.[C.groupType] === 1;
  },
};

const functionFunc = {
  getShift: (allData) => {
    if (allData) {
      return allData[C.srcCodes];
    }
    return null;
  },
  getFunctionName: (allData) => {
    return allData ? allData[C.functionName] : '';
  },
  setFunctionDate: (allData, autoRuleData) => {
    return {
      ...allData,
      [C.srcCodes]: _.map(autoRuleData, (item) => {
        const handleMap = (props) => {
          return _.map(props, (data) => {
            return data.value;
          }).join(',');
        };
        return {
          [C.isDeleted]: item.isDeleted,
          [C.srsWardCode]: item.srsUnitCode,
          [C.srsRankCode]: handleMap(item.srsRankCode),
          [C.srsShiftCode]: handleMap(item.srsShiftCode),
          [C.rosterLeadDay]: handleMap(item.rosterLeadDay),
          [C.staffs]: item.staffs,
          [C.dutyTemplateMappingId]: item.dutyTemplateMappingId ?? null,
        };
      }),
    };
  },
  getId: (allData) => {
    if (allData) {
      if (allData[C.fId] === 0 || allData[C.fId]) {
        return allData[C.fId];
      }
      return allData[C._fId];
    }
    return null;
  },
  getHeight: (allData) => {
    return allData ? allData[C.height] : null;
  },
  setHeight: (allData, height) => {
    return allData ? { ...allData, [C.height]: height } : null;
  },
};

export { newTemplate, ItemTypes, newCubicle, C, allDataFunc, groupDataFunc, functionFunc, templateFunc };
